import { TDeleteReservationParams } from '../../../types/services';
import { asyncTimeout } from '../../../utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from '../../../utils/constants';

export const deleteReservation = async (params: TDeleteReservationParams) => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
